// ===== Packages =====

import {
    FirebaseError,
}                                           from 'firebase/app';

// ===== Services =====

import {
    signIn,
    completeAuthenticatedUserSetup,
    resolveProviderAuthErrorMessage,
}                                           from '.';

// ===== Interfaces =====

import {
    IAuthenticatedUserSetupOldUserData,
}                                           from '../interfaces';

// ===== Enums =====

import {
    AUTHENTICATION_TYPE,
}                                           from '../enums';

const authenticateWithProvider = ({
    test,
    type,
    hasSound,
    oldUserData,
    onSuccess,
    onError,
}: {
    test: boolean,
    type: AUTHENTICATION_TYPE,
    hasSound: boolean,
    oldUserData?: IAuthenticatedUserSetupOldUserData,
    onSuccess: () => void,
    onError: (message: string) => void,
}): void => {
    const resolveAndHandleProviderError = (error: {
        code?: string,
        message?: string,
        customData?: Record<string, unknown>,
    }): void => {
        resolveProviderAuthErrorMessage({
            type,
            error,
        }).then((message) => {
            onError(message);
        });
    };

    signIn({
        type,
        hasSound,
        signingInOut: false,
        oldUserData: {
            user: oldUserData?.user,
            email: oldUserData?.email,
            oldUserCart: oldUserData?.oldUserCart,
            userSessions: oldUserData?.userSessions,
            userUpdateTimestamps: oldUserData?.userUpdateTimestamps,
        },
        onComplete: () => {
            completeAuthenticatedUserSetup({
                test,
                oldUserData,
            })
                .then(() => {
                    onSuccess();
                })
                .catch((error) => {
                    const code = (error as { code?: string } | undefined)?.code;
                    if (code) {
                        resolveAndHandleProviderError({
                            code,
                            message: (error as { message?: string } | undefined)?.message,
                            customData: (
                                error as { customData?: Record<string, unknown> } | undefined
                            )?.customData,
                        });
                        return;
                    }
                    const message = (error as { message?: string } | undefined)?.message
                        || 'There was a problem finishing your account setup.';
                    onError(message);
                });
        },
        onError: (error: FirebaseError) => {
            resolveAndHandleProviderError(error);
        },
    });
};

export default authenticateWithProvider;
